let map;
let markers = [];
let ids = [];
let backHtml = $(".city-block-scroll").html();
const lcclang = document.getElementById('js-data').dataset.lclang;
let currentController = null;

// let mapCoords = `${mapCoords}`;
let mapZoom = Number(document.getElementById('js-data').dataset.zoom);
const button = document.querySelector('#findNearestStore');

function initialize(mapElement, coordsJson, lcclang, mapCoords) {
    if (!mapElement) {
        console.error("Map element is not defined.");
        return;
    }

    const LatLng = mapCoords.split(',');
    const mapOptions = {
        center: new google.maps.LatLng($.trim(LatLng[0]), $.trim(LatLng[1])),
        zoom: mapZoom,
        mapTypeId: google.maps.MapTypeId.ROADMAP,
    };

    map = new google.maps.Map(mapElement, mapOptions);

    if (coordsJson) {
        mapSet(coordsJson, lcclang);
    }
}


function loadStore(id, lclang) {
    if (currentController) currentController.abort();
    currentController = new AbortController();

    return fetch(`/${lclang}/ajax/get_store_info/`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8' },
        body: new URLSearchParams({ id }),
        signal: currentController.signal
    })
        .then(r => r.json())
        .then(data => {
            const block = document.querySelector('.city-block-scroll');
            if (block) block.innerHTML = data.html || '';
            document.querySelectorAll('.card-store.uk-active').forEach(el => el.classList.remove('uk-active'));
            const card = document.querySelector(`[data-store="${id}"]`);
            if (card) card.classList.add('uk-active');
        })
        .catch(err => {
            if (err.name !== 'AbortError') console.error(err);
        })
        .finally(() => { currentController = null; });
}

function mapSet(coordsJson, lclang) {
    coordsJson = coordsJson.replace(/~/g, '"').replace(/[\n\r\t]/g, '');
    const coordsArray = JSON.parse(coordsJson);

    const image = '/public/i/marker.svg';

    for (const value of coordsArray) {
        const [lat, lng] = value.coords.split(',').map(s => s.trim());
        const marker = new google.maps.Marker({
            position: new google.maps.LatLng(lat, lng),
            icon: image,
            map
        });

        markers[value.id] = marker;
        ids.push(marker);

        marker.addListener('click', () => {
            map.setZoom(17);
            map.setCenter(marker.getPosition());
            loadStore(value.id, lclang);
            const shopsCount = document.querySelectorAll('#shopsList .card-store').length;
            if (shopsCount > 1) {
                const newUrl = `${window.location.pathname}?store=${value.id}`;
                window.history.pushState({path: newUrl}, '', newUrl);
            }
        });
    }
}

// Делегирование клика по карточкам (они могут добавляться динамически)
document.addEventListener('click', (e) => {
    const card = e.target.closest('.card-store');
    if (!card) return;

    const id = card.dataset.store;

    if (map && markers[id]) {
        map.setZoom(17);
        map.setCenter(markers[id].getPosition());
    }

    loadStore(id, lcclang);

    // === ВАЖНО ===
    // Меняем URL ТОЛЬКО если магазинов больше одного
    const shopsCount = document.querySelectorAll('#shopsList .card-store').length;
    console.log(shopsCount);
    if (shopsCount > 1) {
        const newUrl = `${window.location.pathname}?store=${id}`;
        window.history.pushState({ path: newUrl }, '', newUrl);
    }
});

function findNearestStore(userLat, userLng) {
    if (!markers.length) {
        console.error("Нет доступных маркеров для поиска.");
        button.classList.remove('uk-disabled');
        return;
    }

    let nearestStore = null;
    let shortestDistance = Infinity;

    Object.values(markers).forEach(marker => {
        if (marker) {
            const markerLat = marker.getPosition().lat();
            const markerLng = marker.getPosition().lng();
            const distance = haversineDistance(userLat, userLng, markerLat, markerLng);

            if (distance < shortestDistance) {
                shortestDistance = distance;
                nearestStore = marker;
            }
        }
    });

    if (nearestStore) {
        google.maps.event.trigger(nearestStore, 'click');
        map.setCenter(nearestStore.getPosition());
        map.setZoom(17);
        google.maps.event.addListenerOnce(map, 'idle', () => {
            button.classList.remove('uk-disabled');
        });
    } else {
        console.error("Не удалось найти ближайший магазин.");
        button.classList.remove('uk-disabled');
    }
}

function haversineDistance(lat1, lng1, lat2, lng2) {
    const toRad = x => (x * Math.PI) / 180;
    const R = 6371;

    const dLat = toRad(lat2 - lat1);
    const dLng = toRad(lng2 - lng1);

    const a =
        Math.sin(dLat / 2) * Math.sin(dLat / 2) +
        Math.cos(toRad(lat1)) * Math.cos(toRad(lat2)) *
        Math.sin(dLng / 2) * Math.sin(dLng / 2);

    const c = 2 * Math.atan2(Math.sqrt(a), Math.sqrt(1 - a));
    return R * c;
}

document.getElementById('findNearestStore').addEventListener('click', function () {
    button.classList.add('uk-disabled');
    if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
            position => {
                const userLat = position.coords.latitude;
                const userLng = position.coords.longitude;
                findNearestStore(userLat, userLng);
            },
            error => {
                console.error("Не удалось получить геолокацию: ", error.message);
                button.classList.remove('uk-disabled');
            }
        );
    } else {
        console.error("Геолокация не поддерживается вашим браузером.");
        button.classList.remove('uk-disabled');
    }
});

function filter(){
    const query = document.getElementById('searchStore').value.toLowerCase().trim();
    const shops = document.querySelectorAll('#shopsList .card-store');

    let foundShop = null;

    shops.forEach(shop => {
        const name = shop.querySelector('p.title').textContent.toLowerCase();
        const address = shop.querySelector('p:not(.title)').textContent.toLowerCase();

        if (name.includes(query) || address.includes(query)) {
            shop.closest('li').classList.remove('card-hidden');
            foundShop = shop;
        } else {
            shop.closest('li').classList.add('card-hidden');
        }
    });
}

document.getElementById('searchStore').addEventListener('input', function () {
    filter();
});

const inputField = document.getElementById('searchStore');
const clearButton = document.querySelector('.clear-input');


clearButton.addEventListener('click', () => {
    const shops = document.querySelectorAll('#shopsList .card-store');
    shops.forEach(shop => {
        shop.closest('li').classList.remove('card-hidden');
    });
    inputField.value = '';
    inputField.focus();
});

document.addEventListener('DOMContentLoaded', function () {
    updateCityName();

    const urlParams = new URLSearchParams(window.location.search);
    const storeId = urlParams.get('store');

    if (storeId) {
        setTimeout(() => {
            const targetCard = document.querySelector(`.card-store[data-store="${storeId}"]`);
            if (targetCard) {
                targetCard.classList.add('uk-active');
                targetCard.click();
            } else {
                console.warn('Магазин с указанным ID не найден.');
            }
        }, 100);
    } else {
        if (map) {
            const defaultLatLng = mapCoords.split(',');
            const defaultCenter = new google.maps.LatLng($.trim(defaultLatLng[0]), $.trim(defaultLatLng[1]));
            map.setCenter(defaultCenter);
            map.setZoom(mapZoom);
        } else {
            console.error('Карта не инициализирована.');
        }
    }

    document.querySelectorAll('.card-store').forEach(function (card) {
        card.addEventListener('click', function () {
            let storeId = card.getAttribute('data-store');
            const shopsCount = document.querySelectorAll('#shopsList .card-store').length;

            if (shopsCount > 1) {
                let newUrl = `${window.location.pathname}?store=${storeId}`;
                window.history.pushState({path: newUrl}, '', newUrl);
            }
        });
    });

    const loadind = document.querySelector('#shopsList');

    $('[uk-filter]').on('afterFilter', function () {
        setTimeout(() => {
            filter();
            const allItems = document.querySelectorAll('.card-store');
            const visibleItems = Array.from(allItems).filter(item => {
                const parent = item.closest('li');
                return parent && parent.style.display !== "none";
            });
            if (visibleItems.length === 1) {
                const targetCard = visibleItems[0];
                targetCard.click();
            } else {
                let newUrl = `${window.location.pathname}`;
                window.history.pushState({path: newUrl}, '', newUrl);
            }
            loadind.classList.remove('loading');
        }, 50);
    });

    $('[uk-filter]').on('beforeFilter', function () {
        loadind.classList.add('loading');
        const allItems = document.querySelectorAll('li');
        allItems.forEach(item => {
            item.closest('li').classList.remove('card-hidden');
        });
    });

    const shopCards = document.querySelectorAll('#shopsList .card-store');
    if (shopCards.length === 1) {
        const singleShop = shopCards[0];
        singleShop.classList.add('uk-active');
        singleShop.click();
        setTimeout(() => {
            map.setZoom(17);
        }, 500);
    }
});

$(document).on("click", ".filter-city.list-city a", function (event) {
    event.preventDefault();
    let coords = $(this).data('coords');
    let zoom = $(this).data('zoom');
    $(".city-block-scroll").html(backHtml);
    $('.card-store').removeClass('uk-active');
    updateCityName();

    if (map) {
        map.setZoom(zoom);
        const LatLng = coords.split(',');
        map.setCenter(new google.maps.LatLng($.trim(LatLng[0]), $.trim(LatLng[1])));
    } else {
        console.error("Карта не инициализирована.");
    }
});


$(document).on("click", ".map-btn", function (event) {
    event.preventDefault();

    const storeId = $(this).data("id-store");
    if (!storeId) return;

    UIkit.scroll($(this), { offset: 100 }).scrollTo(".stores .map #map");

    const openStoreOnMap = () => {
        if (map && markers[storeId]) {
            $('.card-store').removeClass('uk-active');
            const card = $(`.card-store[data-store="${storeId}"]`);
            card.addClass('uk-active');
            card.click();

            google.maps.event.trigger(markers[storeId], 'click');
            map.setZoom(17);
            map.setCenter(markers[storeId].getPosition());
            return true;
        }
        return false;
    };

    // Пробуем открыть сразу
    if (!openStoreOnMap()) {
        // Если карта или маркер ещё не готовы — повторяем попытку через интервал
        const interval = setInterval(() => {
            if (openStoreOnMap()) clearInterval(interval);
        }, 300);

        // Безопасный таймаут
        setTimeout(() => clearInterval(interval), 4000);
    }
});
